// extracted by mini-css-extract-plugin
module.exports = {"column":"TableColumn_column__Aw8-w","clickable":"TableColumn_clickable__z154K"};